<div class="plan-page__banner">
    <Banner close={i18n.close} visible={bannerVisible} type={bannerType}>
        <span>
            {message}

            {#if showRefreshButton}
                <span>{i18n.addedFilesPleaseRefresh}</span>
                <button on:click={refresh} class="planner-banner-refresh" type="button">
                    {i18n.refresh}
                </button>
            {/if}
        </span>
    </Banner>
</div>

<script>
    import { onMount } from "svelte";

    import Banner from "@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte";

    import i18n from "@its-ui/planner-common/i18n";
    import { getPlanFilesUploadStatus } from "@its-ui/planner-common/api";
    import { plannerFilesUploadStatus } from "@its-ui/planner-common/constants";
    import { refreshPlanResources } from "../../main";

    export let planId;
    export let isUploadStarted;

    let uploadStatus = plannerFilesUploadStatus.none;
    let bannerType = "info";
    let message = "";
    let uploadStatusPollingTimerId = 0;
    let isUploadInProgressOnPage = false;

    $: bannerVisible = uploadStatus !== plannerFilesUploadStatus.none;
    $: showRefreshButton =
        isUploadInProgressOnPage && uploadStatus === plannerFilesUploadStatus.success;

    $: {
        switch (uploadStatus) {
            case plannerFilesUploadStatus.none:
                bannerType = "";
                message = "";
                break;
            case plannerFilesUploadStatus.inProgress:
                bannerType = "loading";
                message = i18n.addedFilesInProgress;
                break;
            case plannerFilesUploadStatus.success:
                bannerType = "success";
                message = i18n.addedFilesSuccess;
                break;
            case plannerFilesUploadStatus.error:
                bannerType = "warning";
                message = i18n.addedFilesError;
                break;
        }
    }

    $: {
        if (uploadStatus !== plannerFilesUploadStatus.inProgress) {
            stopPolling();
        } else {
            startUploadStatusPollingIfNeed();
        }
    }

    $: {
        if (isUploadStarted) {
            checkUploadStatus();
        }
    }

    onMount(() => {
        checkUploadStatus();
    });

    function checkUploadStatus() {
        getPlanFilesUploadStatus(planId).then(data => {
            uploadStatus = data.status;
        });
    }

    function startUploadStatusPollingIfNeed() {
        if (uploadStatusPollingTimerId === 0) {
            isUploadInProgressOnPage = true;
            uploadStatusPollingTimerId = setInterval(() => {
                checkUploadStatus();
            }, 3000);
        }
    }

    function stopPolling() {
        clearInterval(uploadStatusPollingTimerId);
        uploadStatusPollingTimerId = 0;
        isUploadInProgressOnPage = false;
        isUploadStarted = false;
    }

    function refresh() {
        refreshPlanResources();
        uploadStatus = plannerFilesUploadStatus.none;
    }
</script>
